import {useContext} from "react";
import StepContext from "../Components/Fundamentals/Stepper/StepContext";

export function useStep() {
    return useContext(StepContext);
}